var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("登录中，请稍后。。。"),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("重新登录")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }